<template>
  <div class="main">
    <!-- <a-button type="primary" @click="addTime">添加时段</a-button>
        <div class="table">
            <div class="title">在线巡查时间段设置</div>
            <div class="th" style="height:40px">
                <div>开始时间</div>
                <div>终止时间</div>
                <div>操作</div>
            </div>
            <div class="content" style="margin-top:0px;">
                <div class="itemTime" v-for="(item, index) in timeDataList" :key="index">
                    <div>
                        {{ item.startTime }}
                    </div>
                    <div>
                        {{ item.endTime }}
                    </div>
                    <div class="tableImg" @click="delBtn(item.id)"></div>
                </div>
            </div>
        </div> -->
    <div class="handleTime">
      <div class="titleTimes">护工异常处理时间阈值</div>
      <div class="info">
        <div>{{ handleTimeVal }}</div>
        <a-icon type="form" @click="editHandleTime" class="tableIcon" />
      </div>
    </div>
    <!-- 添加时段 -->
    <a-modal
      title="添加时段"
      :width="400"
      :visible="addTimePopup"
      @cancel="addTimeCancel"
      :maskClosable="false"
      :footer="null"
    >
      <div class="picker">
        <div class="titleTime">开始时间</div>
        <a-time-picker
          class="acol_statr_input"
          format="HH:mm"
          v-model="startTime"
          :allowClear="false"
        />
      </div>
      <div class="picker">
        <div class="titleTime">终止时间</div>
        <a-time-picker
          class="acol_statr_input"
          format="HH:mm"
          v-model="endTime"
          :allowClear="false"
        />
      </div>
      <div class="addBtn">
        <a-button style="margin-right: 10px;" @click="addTimeCancel"
          >取消</a-button
        >
        <a-button type="primary" @click="addTimeOk" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal>
    <!-- 删除弹窗 -->
    <a-modal
      title=""
      :width="200"
      :visible="delTimePopup"
      :footer="null"
      :closable="false"
    >
      <p class="delTips">
        <a-icon type="exclamation-circle" />你确定要删除吗？
      </p>
      <div class="delBtn">
        <a-button style="margin-right: 10px;" @click="delTimeCancel"
          >取消</a-button
        >
        <a-button type="primary" @click="delTimeOk" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal>
    <!-- 修改护工异常处理时间阈值弹窗 -->
    <a-modal
      title="修改阈值"
      :width="400"
      :visible="editHandleTimePopup"
      :footer="null"
      :closable="false"
    >
      <div class="timeValBox">
        <div>离床到异常时间阈值</div>
        <a-time-picker
          :allowClear="false"
          v-model="editHandleTimeVal"
          format="HH:mm:ss"
        ></a-time-picker>
      </div>
      <div class="editBtn">
        <a-button style="margin-right: 10px;" @click="editHandleTimeCancel"
          >取消</a-button
        >
        <a-button type="primary" @click="editHandleTimeOk" :loading="loading"
          >确定</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data() {
    return {
      timeDataList: [],
      startTime: this.$moment('', 'HH:mm'),
      endTime: this.$moment('', 'HH:mm'),
      delTimePopup: false, // 删除弹窗
      addTimePopup: false, // 添加弹窗
      editHandleTimePopup: false, // 修改默认阈值弹窗
      typeId: '', // 时段id
      loading: false,
      open: false,
      handleTimeVal: '', // 护工异常处理时间阈值
      editHandleTimeVal: '',
    };
  },
  mounted() {
    this.getTimeData();
    this.getThresholdData();
  },
  methods: {
    moment,
    // 添加时段
    addTime() {
      this.addTimePopup = true;
      this.startTime = '';
      this.endTime = '';
    },
    // 确定添加
    addTimeOk() {
      if (this.startTime == '') {
        this.$message.error('请选择开始时间');
        return;
      }
      if (this.endTime == '') {
        this.$message.error('请选择终止时间');
        return;
      }
      let param = {
        startTime: this.$dateTime(this.startTime._d).time,
        endTime: this.$dateTime(this.endTime._d).time,
      };
      this.loading = true;
      this.$post(
        '/api/nurse/MonitorTime',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTimeData();
            this.addTimePopup = false;
            this.$message.success('添加成功');
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
          this.loading = false;
        }
      );
    },
    change(dates, dateStrings) {
      let param = {
        startTime: dateStrings,
        endTime: dateStrings,
      };
      this.loading = true;
      this.$post(
        '/api/nurse/MonitorTime',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTimeData();
            this.addTimePopup = false;
            this.$message.success('添加成功');
          } else {
            this.$message.error(res.msg);
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
          this.loading = false;
        }
      );
    },
    // 添加取消
    addTimeCancel() {
      this.addTimePopup = false;
    },
    // 修改时段
    editTimeOk(index, type) {
      if (type == 1) {
        var startTime = this.$dateTime(this.timeDataList[index].startTime).time;
        var endTime = this.timeDataList[index].endTime;
      } else {
        var startTime = this.timeDataList[index].startTime;
        var endTime = this.$dateTime(this.timeDataList[index].endTime).time;
      }
      let param = {
        startTime: startTime,
        endTime: endTime,
      };
      this.$post(
        '/api/nurse/MonitorTime',
        param,
        (res) => {
          if (res.code == 0) {
            this.getTimeData();
            this.$message.success('修改成功');
          } else {
            this.$message.error(res.msg);
          }
          if (type == 1) {
            this.timeDataList[index].open1 = false;
          } else {
            this.timeDataList[index].open2 = false;
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 获取时段数据
    getTimeData() {
      this.$get(
        '/api/nurse/MonitorTime',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              // let arr = [];
              // for(let i = 0;i < res.data.length;i++){
              //     arr.push({
              //         startTime: this.$moment(res.data[i].startTime, 'HH:mm'),
              //         endTime: this.$moment(res.data[i].endTime, 'HH:mm'),
              //         id: res.data[i].id,
              //         open1: false,
              //         open2: false
              //     })
              // }
              // this.timeDataList = arr;
              this.timeDataList = res.data;
            } else {
              this.timeDataList = [];
            }
            // console.log(arr)
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 删除按钮
    delBtn(e) {
      this.delTimePopup = true;
      this.typeId = e;
    },
    // 删除取消
    delTimeCancel() {
      this.delTimePopup = false;
    },
    // 删除确定
    delTimeOk() {
      this.$delete(
        '/api/nurse/MonitorTime/' + this.typeId,
        {},
        (res) => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.delTimePopup = false;
            this.getTimeData();
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 获取默认阈值
    getThresholdData() {
      this.$get(
        '/api/nurse/abnormalTime',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.handleTimeVal = JSON.parse(res.data.value);
              this.typeIdVal = res.data.id;
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 修改默认阈值按钮
    editHandleTime() {
      this.editHandleTimePopup = true;
      this.editHandleTimeVal = this.$moment(this.handleTimeVal, 'HH:mm:ss');
    },
    // 确定修改默认阈值按钮
    editHandleTimeOk() {
      let param = {
        id: this.typeIdVal,
        value:
          this.$dateTime(this.editHandleTimeVal._d).time +
          ':' +
          this.$dateTime(this.editHandleTimeVal._d).seconds,
      };
      this.$put(
        '/api/nurse/abnormalTime',
        param,
        (res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
            this.editHandleTimePopup = false;
            this.getThresholdData();
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 取消默认阈值按钮
    editHandleTimeCancel() {
      this.editHandleTimePopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.main::v-deep {
  padding: 0 !important;
  .table {
    width: 570px;
    border-radius: 4px 4px 0px 0px;
    border: 1px solid #e8e8e8;
    margin-top: 10px;
    .title {
      background: #f0f0f0;
      height: 47px;
      text-align: center;
      line-height: 47px;
      color: #262626;
    }
    .content {
      .itemTime {
        display: flex;
        align-items: center;
        height: 42px;
        line-height: 40px;
        border-top: 1px solid #e8e8e8;
        div {
          flex: 1;
          text-align: center;
        }
        .tableImg {
          width: 18px;
          height: 30px;
          cursor: pointer;
          background: url('../../assets/icon_trashCan_nor.png') no-repeat center;
        }
        .tableImg:hover {
          background: url('../../assets/icon_trashCan_ove.png') no-repeat center;
        }
        .acol_statr_input {
          input {
            border: none;
            height: auto;
            padding: 0;
          }
          .ant-time-picker-icon {
            display: none;
          }
        }
        .ant-time-picker-icon,
        .ant-time-picker-clear {
          display: none;
        }
        .ant-time-picker {
          width: 80px;
        }
        .ant-time-picker-input {
          padding: 0;
          text-align: center;
        }
        .ant-time-picker-input::-ms-input-placeholder {
          text-align: center;
        }
        .ant-time-picker-input::-webkit-input-placeholder {
          text-align: center;
        }
      }
    }
  }
  .handleTime {
    width: 570px;
    height: 47px;
    display: flex;
    border: 1px solid #e8e8e8;
    border-radius: 4px 0px 0px 4px;
    margin-top: 20px;
    .titleTimes {
      width: 30%;
      text-align: center;
      background: #f0f0f0;
      line-height: 47px;
      margin-right: 20px;
    }
    .info {
      width: 70%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      > div {
        flex: 1;
      }
      .tableIcon {
        color: #1890ff;
        font-size: 20px;
        cursor: pointer;
        flex: 1;
      }
      .tableIcon:hover {
        color: #0072db;
      }
    }
  }
  .th {
    display: flex;
    height: 40px;
    line-height: 40px;
    div {
      flex: 1;
      text-align: center;
    }
  }
}
.picker {
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  .titleTime {
    margin-right: 10px;
  }
}
.addBtn {
  text-align: right;
}
.delTips {
  .anticon {
    color: #faad14;
    margin-right: 10px;
  }
}
.delBtn {
  text-align: right;
  .ant-btn {
    height: 24px;
    line-height: 24px;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
  }
}
.timeValBox {
  display: flex;
  > div {
    line-height: 32px;
    margin-right: 10px;
  }
}
.editBtn {
  text-align: right;
  margin-top: 20px;
  .ant-btn {
    border-radius: 2px;
    font-size: 14px;
  }
}
</style>
